import Link from "next/link";
import { Card, CardContent } from "./ui/card";
import Image from "next/image";
import { Salon } from "@/app/lib/salons";
import { slugify } from "@/lib/utils";

const PersonalAd = ({ featuredSalon }: { featuredSalon: Salon }) => {
    // This component now requires a featuredSalon and won't render the generic ad.
    const adData = {
        imageUrl: featuredSalon.pagePicture || "https://i.imgur.com/jxPp6TP.png",
        altText: `Uitgelicht: ${featuredSalon.name}`,
        link: `/hondenkapsalons-in-antwerpen/${slugify(featuredSalon.area)}/${featuredSalon.slug}`,
        title: featuredSalon.name,
        description: `Uitgelicht in ${featuredSalon.area}`
    };
    
    return (
        <div className="relative pt-3">
            <div className="absolute top-0 left-4 bg-background px-2 py-0.5 text-[10px] font-black text-muted-foreground uppercase tracking-widest z-10 border rounded-full shadow-sm">
                Advertentie
            </div>
            <Card className="overflow-hidden group">
                <Link href={adData.link}>
                    <CardContent className="p-0">
                        <div className="relative aspect-[4/1]">
                            <Image 
                                src={adData.imageUrl}
                                alt={adData.altText}
                                fill
                                className="object-cover transition-transform duration-300 group-hover:scale-105"
                                data-ai-hint="advertisement banner"
                            />
                            <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center p-4 text-center">
                                <h3 className="text-white font-bold text-lg md:text-xl drop-shadow-md">{adData.title}</h3>
                                <p className="text-white/90 text-sm md:text-base drop-shadow-sm">{adData.description}</p>
                            </div>
                        </div>
                    </CardContent>
                </Link>
            </Card>
        </div>
    );
};

export default PersonalAd;
